import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { NavLink } from 'react-router-dom';
import { MessagesInbox } from './MessagesInbox';
import { MessagesArchive } from './MessagesArchive';
import { TournamentConfirmationMessagesInbox } from './TournamentConfirmationMessagesInbox';
import { TournamentConfirmationMessagesArchive } from './TournamentConfirmationMessagesArchive';
import './Messages.scss';

export const MessagesRouting = allProps => {
  const pathname = allProps.location.pathname;
  const folders = [
    { key: 'inbox', label: 'Inbox' },
    { key: 'outbox', label: 'Outbox' },
    { key: 'archive', label: 'Archive' }
  ];
  const activeFolder = folders.find(folder => pathname.indexOf(`/messages/${folder.key}`) === 0);

  React.useEffect(() => {
    const breadcrumb = activeFolder ? `Messages / ${activeFolder.label}` : 'Messages';
    window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb', { detail: breadcrumb }));

    return () => {
      window.dispatchEvent(new CustomEvent('sit:topbar-breadcrumb-clear'));
    };
  }, [activeFolder && activeFolder.key]);

  return (
    <div className="messagesHub">
      <header className="messagesHub__header">
        <h1>Messages</h1>
        <nav className="messagesHub__tabs" aria-label="Message folders">
          {folders.map(folder => (
            <NavLink
              key={folder.key}
              exact
              to={`/messages/${folder.key}`}
              activeClassName="is-active"
            >
              {folder.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <Switch>
        <Route exact path={'/messages'} render={() => <Redirect to="/messages/inbox" />} />
        <Route
          exact
          path={'/messages/inbox'}
          render={props => <MessagesInbox {...props} user={allProps.user} setNeedUpdate={allProps.setNeedUpdate} />}
        />
        <Route
          exact
          path={'/messages/outbox'}
          render={props => <MessagesArchive key="outbox" {...props} user={allProps.user} mode="outbox" />}
        />
        <Route
          exact
          path={'/messages/archive'}
          render={props => <MessagesArchive key="archive" {...props} user={allProps.user} />}
        />

        {/* Updated routes for Tournament Confirmation Requests */}
        <Route
          exact
          path={'/messages/tournamentConfirmationRequests/inbox'}
          render={props => <TournamentConfirmationMessagesInbox {...props} user={allProps.user} />}
        />
        <Route
          exact
          path={'/messages/tournamentConfirmationRequests/archive'}
          render={props => <TournamentConfirmationMessagesArchive {...props} user={allProps.user} />}
        />
      </Switch>
    </div>
  );
};

MessagesRouting.displayName = 'MessagesRouting';
